import { combineReducers } from "redux";

import apiCallStatusReducer from "./apiCallStatus.reducer";
import appStatusReducer from "./appStatus.reducer";
import authReducer from "./auth.reducer";
import chatReducer from "./chat.reducer";
import codeEditorReducer from "./codeEditor.reducer";
import codingProblemsReducer from "./codingProblems.reducer";
import collabTemporaryDataReducer from "./collabTemporaryData.reducer";
import createQuestionModalReducer from "./createQuestionModal.reducer";
import interviewReducer from "./interview.reducer";
import interviewerRatingsReducer from "./interviewer.reducer";
import libraryReducer from "./library.reducers";
import modalReducer from "./modal.reducer";
import participantsReducer from "./participants.reducer";
import interviewPermissionReducer from "./permissions.reducer";
import progressReducer from "./progress.reducer";
import questionsReducer from "./questions.reducer";
import socketReducer from "./socket.reducer";
import serverTimeReducer from "./serverTime.reducer";
import solutionsReducer from "./solutions.reducer";
import zoomClientReducer from "./zoomClient.reducer";
import zoomGlobalReducer from "./zoomGlobal.reducer";
import platformMetaReducer from "./platformMeta.reducer";
import interviewConfigReducer from "./interviewConfig.reducer";

const rootReducer = combineReducers({
  apiCallStatus: apiCallStatusReducer,
  auth: authReducer,
  collabTemporaryData: collabTemporaryDataReducer,
  platformMeta: platformMetaReducer,
  interviewConfig: interviewConfigReducer,
  zoomClient: zoomClientReducer,
  zoomGlobal: zoomGlobalReducer,
  chat: chatReducer,
  codeEditor: codeEditorReducer,
  codingProblems: codingProblemsReducer,
  questionsDetails: questionsReducer,
  library: libraryReducer,
  progress: progressReducer,
  interview: interviewReducer,
  interviewerRatings: interviewerRatingsReducer,
  participants: participantsReducer,
  socket: socketReducer,
  serverTime: serverTimeReducer,
  appStatus: appStatusReducer,
  modal: modalReducer,
  solutions: solutionsReducer,
  createQuestionModal: createQuestionModalReducer,
  interviewPermissions: interviewPermissionReducer,
});

export default rootReducer;
